/****************************************************************
 * Js imports
 ****************************************************************/
/* jQuery elevateZoom 3.0.8 - Demo's and documentation: - www.elevateweb.co.uk/image-zoom - Copyright (c) 2013 Andrew Eades - www.elevateweb.co.uk - Dual licensed under the LGPL licenses. - http://en.wikipedia.org/wiki/MIT_License - http://en.wikipedia.org/wiki/GNU_General_Public_License */
"function"!==typeof Object.create&&(Object.create=function(d){function h(){}h.prototype=d;return new h});
(function(d,h,l,m){var k={init:function(b,a){var c=this;c.elem=a;c.$elem=d(a);c.imageSrc=c.$elem.data("zoom-image")?c.$elem.data("zoom-image"):c.$elem.attr("src");c.options=d.extend({},d.fn.elevateZoom.options,b);c.options.tint&&(c.options.lensColour="none",c.options.lensOpacity="1");"inner"==c.options.zoomType&&(c.options.showLens=!1);c.$elem.parent().removeAttr("title").removeAttr("alt");c.zoomImage=c.imageSrc;c.refresh(1);d("#"+c.options.gallery+" a").click(function(a){c.options.galleryActiveClass&&
(d("#"+c.options.gallery+" a").removeClass(c.options.galleryActiveClass),d(this).addClass(c.options.galleryActiveClass));a.preventDefault();d(this).data("zoom-image")?c.zoomImagePre=d(this).data("zoom-image"):c.zoomImagePre=d(this).data("image");c.swaptheimage(d(this).data("image"),c.zoomImagePre);return!1})},refresh:function(b){var a=this;setTimeout(function(){a.fetch(a.imageSrc)},b||a.options.refresh)},fetch:function(b){var a=this,c=new Image;c.onload=function(){a.largeWidth=c.width;a.largeHeight=
c.height;a.startZoom();a.currentImage=a.imageSrc;a.options.onZoomedImageLoaded(a.$elem)};c.src=b},startZoom:function(){var b=this;b.nzWidth=b.$elem.width();b.nzHeight=b.$elem.height();b.isWindowActive=!1;b.isLensActive=!1;b.isTintActive=!1;b.overWindow=!1;b.options.imageCrossfade&&(b.zoomWrap=b.$elem.wrap('<div style="height:'+b.nzHeight+"px;width:"+b.nzWidth+'px;" class="zoomWrapper" />'),b.$elem.css("position","absolute"));b.zoomLock=1;b.scrollingLock=!1;b.changeBgSize=!1;b.currentZoomLevel=b.options.zoomLevel;
b.nzOffset=b.$elem.offset();b.widthRatio=b.largeWidth/b.currentZoomLevel/b.nzWidth;b.heightRatio=b.largeHeight/b.currentZoomLevel/b.nzHeight;"window"==b.options.zoomType&&(b.zoomWindowStyle="overflow: hidden;background-position: 0px 0px;text-align:center;background-color: "+String(b.options.zoomWindowBgColour)+";width: "+String(b.options.zoomWindowWidth)+"px;height: "+String(b.options.zoomWindowHeight)+"px;float: left;background-size: "+b.largeWidth/b.currentZoomLevel+"px "+b.largeHeight/b.currentZoomLevel+
"px;display: none;z-index:100;border: "+String(b.options.borderSize)+"px solid "+b.options.borderColour+";background-repeat: no-repeat;position: absolute;");if("inner"==b.options.zoomType){var a=b.$elem.css("border-left-width");b.zoomWindowStyle="overflow: hidden;margin-left: "+String(a)+";margin-top: "+String(a)+";background-position: 0px 0px;width: "+String(b.nzWidth)+"px;height: "+String(b.nzHeight)+"px;float: left;display: none;cursor:"+b.options.cursor+";px solid "+b.options.borderColour+";background-repeat: no-repeat;position: absolute;"}"window"==
b.options.zoomType&&(lensHeight=b.nzHeight<b.options.zoomWindowWidth/b.widthRatio?b.nzHeight:String(b.options.zoomWindowHeight/b.heightRatio),lensWidth=b.largeWidth<b.options.zoomWindowWidth?b.nzWidth:b.options.zoomWindowWidth/b.widthRatio,b.lensStyle="background-position: 0px 0px;width: "+String(b.options.zoomWindowWidth/b.widthRatio)+"px;height: "+String(b.options.zoomWindowHeight/b.heightRatio)+"px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:"+
b.options.lensOpacity+";filter: alpha(opacity = "+100*b.options.lensOpacity+"); zoom:1;width:"+lensWidth+"px;height:"+lensHeight+"px;background-color:"+b.options.lensColour+";cursor:"+b.options.cursor+";border: "+b.options.lensBorderSize+"px solid "+b.options.lensBorderColour+";background-repeat: no-repeat;position: absolute;");b.tintStyle="display: block;position: absolute;background-color: "+b.options.tintColour+";filter:alpha(opacity=0);opacity: 0;width: "+b.nzWidth+"px;height: "+b.nzHeight+"px;";
b.lensRound="";"lens"==b.options.zoomType&&(b.lensStyle="background-position: 0px 0px;float: left;display: none;border: "+String(b.options.borderSize)+"px solid "+b.options.borderColour+";width:"+String(b.options.lensSize)+"px;height:"+String(b.options.lensSize)+"px;background-repeat: no-repeat;position: absolute;");"round"==b.options.lensShape&&(b.lensRound="border-top-left-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;border-top-right-radius: "+String(b.options.lensSize/2+b.options.borderSize)+
"px;border-bottom-left-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;border-bottom-right-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;");b.zoomContainer=d('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:'+b.nzOffset.left+"px;top:"+b.nzOffset.top+"px;height:"+b.nzHeight+"px;width:"+b.nzWidth+'px;"></div>');d("body").append(b.zoomContainer);b.options.containLensZoom&&"lens"==b.options.zoomType&&b.zoomContainer.css("overflow",
"hidden");"inner"!=b.options.zoomType&&(b.zoomLens=d("<div class='zoomLens' style='"+b.lensStyle+b.lensRound+"'>&nbsp;</div>").appendTo(b.zoomContainer).click(function(){b.$elem.trigger("click")}),b.options.tint&&(b.tintContainer=d("<div/>").addClass("tintContainer"),b.zoomTint=d("<div class='zoomTint' style='"+b.tintStyle+"'></div>"),b.zoomLens.wrap(b.tintContainer),b.zoomTintcss=b.zoomLens.after(b.zoomTint),b.zoomTintImage=d('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: '+
b.nzWidth+"px; height: "+b.nzHeight+'px;" src="'+b.imageSrc+'">').appendTo(b.zoomLens).click(function(){b.$elem.trigger("click")})));isNaN(b.options.zoomWindowPosition)?b.zoomWindow=d("<div style='z-index:999;left:"+b.windowOffsetLeft+"px;top:"+b.windowOffsetTop+"px;"+b.zoomWindowStyle+"' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function(){b.$elem.trigger("click")}):b.zoomWindow=d("<div style='z-index:999;left:"+b.windowOffsetLeft+"px;top:"+b.windowOffsetTop+"px;"+b.zoomWindowStyle+
"' class='zoomWindow'>&nbsp;</div>").appendTo(b.zoomContainer).click(function(){b.$elem.trigger("click")});b.zoomWindowContainer=d("<div/>").addClass("zoomWindowContainer").css("width",b.options.zoomWindowWidth);b.zoomWindow.wrap(b.zoomWindowContainer);"lens"==b.options.zoomType&&b.zoomLens.css({backgroundImage:"url('"+b.imageSrc+"')"});"window"==b.options.zoomType&&b.zoomWindow.css({backgroundImage:"url('"+b.imageSrc+"')"});"inner"==b.options.zoomType&&b.zoomWindow.css({backgroundImage:"url('"+b.imageSrc+
"')"});b.$elem.bind("touchmove",function(a){a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])});b.zoomContainer.bind("touchmove",function(a){"inner"==b.options.zoomType&&b.showHideWindow("show");a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])});b.zoomContainer.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")});
b.$elem.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")});b.options.showLens&&(b.zoomLens.bind("touchmove",function(a){a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])}),b.zoomLens.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")}));
b.$elem.bind("mousemove",function(a){!1==b.overWindow&&b.setElements("show");if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.zoomContainer.bind("mousemove",function(a){!1==b.overWindow&&b.setElements("show");if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});"inner"!=b.options.zoomType&&b.zoomLens.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),
b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.options.tint&&"inner"!=b.options.zoomType&&b.zoomTint.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});"inner"==b.options.zoomType&&b.zoomWindow.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.zoomContainer.add(b.$elem).mouseenter(function(){!1==b.overWindow&&
b.setElements("show")}).mouseleave(function(){b.scrollLock||b.setElements("hide")});"inner"!=b.options.zoomType&&b.zoomWindow.mouseenter(function(){b.overWindow=!0;b.setElements("hide")}).mouseleave(function(){b.overWindow=!1});b.minZoomLevel=b.options.minZoomLevel?b.options.minZoomLevel:2*b.options.scrollZoomIncrement;b.options.scrollZoom&&b.zoomContainer.add(b.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll",function(a){b.scrollLock=!0;clearTimeout(d.data(this,"timer"));d.data(this,"timer",
setTimeout(function(){b.scrollLock=!1},250));var e=a.originalEvent.wheelDelta||-1*a.originalEvent.detail;a.stopImmediatePropagation();a.stopPropagation();a.preventDefault();0<e/120?b.currentZoomLevel>=b.minZoomLevel&&b.changeZoomLevel(b.currentZoomLevel-b.options.scrollZoomIncrement):b.options.maxZoomLevel?b.currentZoomLevel<=b.options.maxZoomLevel&&b.changeZoomLevel(parseFloat(b.currentZoomLevel)+b.options.scrollZoomIncrement):b.changeZoomLevel(parseFloat(b.currentZoomLevel)+b.options.scrollZoomIncrement);
return!1})},setElements:function(b){if(!this.options.zoomEnabled)return!1;"show"==b&&this.isWindowSet&&("inner"==this.options.zoomType&&this.showHideWindow("show"),"window"==this.options.zoomType&&this.showHideWindow("show"),this.options.showLens&&this.showHideLens("show"),this.options.tint&&"inner"!=this.options.zoomType&&this.showHideTint("show"));"hide"==b&&("window"==this.options.zoomType&&this.showHideWindow("hide"),this.options.tint||this.showHideWindow("hide"),this.options.showLens&&this.showHideLens("hide"),
this.options.tint&&this.showHideTint("hide"))},setPosition:function(b){if(!this.options.zoomEnabled)return!1;this.nzHeight=this.$elem.height();this.nzWidth=this.$elem.width();this.nzOffset=this.$elem.offset();this.options.tint&&"inner"!=this.options.zoomType&&(this.zoomTint.css({top:0}),this.zoomTint.css({left:0}));this.options.responsive&&!this.options.scrollZoom&&this.options.showLens&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/
this.heightRatio),lensWidth=this.largeWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/this.widthRatio,this.widthRatio=this.largeWidth/this.nzWidth,this.heightRatio=this.largeHeight/this.nzHeight,"lens"!=this.options.zoomType&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/this.heightRatio),lensWidth=this.options.zoomWindowWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/
this.widthRatio,this.zoomLens.css("width",lensWidth),this.zoomLens.css("height",lensHeight),this.options.tint&&(this.zoomTintImage.css("width",this.nzWidth),this.zoomTintImage.css("height",this.nzHeight))),"lens"==this.options.zoomType&&this.zoomLens.css({width:String(this.options.lensSize)+"px",height:String(this.options.lensSize)+"px"}));this.zoomContainer.css({top:this.nzOffset.top});this.zoomContainer.css({left:this.nzOffset.left});this.mouseLeft=parseInt(b.pageX-this.nzOffset.left);this.mouseTop=
parseInt(b.pageY-this.nzOffset.top);"window"==this.options.zoomType&&(this.Etoppos=this.mouseTop<this.zoomLens.height()/2,this.Eboppos=this.mouseTop>this.nzHeight-this.zoomLens.height()/2-2*this.options.lensBorderSize,this.Eloppos=this.mouseLeft<0+this.zoomLens.width()/2,this.Eroppos=this.mouseLeft>this.nzWidth-this.zoomLens.width()/2-2*this.options.lensBorderSize);"inner"==this.options.zoomType&&(this.Etoppos=this.mouseTop<this.nzHeight/2/this.heightRatio,this.Eboppos=this.mouseTop>this.nzHeight-
this.nzHeight/2/this.heightRatio,this.Eloppos=this.mouseLeft<0+this.nzWidth/2/this.widthRatio,this.Eroppos=this.mouseLeft>this.nzWidth-this.nzWidth/2/this.widthRatio-2*this.options.lensBorderSize);0>=this.mouseLeft||0>this.mouseTop||this.mouseLeft>this.nzWidth||this.mouseTop>this.nzHeight?this.setElements("hide"):(this.options.showLens&&(this.lensLeftPos=String(this.mouseLeft-this.zoomLens.width()/2),this.lensTopPos=String(this.mouseTop-this.zoomLens.height()/2)),this.Etoppos&&(this.lensTopPos=0),
this.Eloppos&&(this.tintpos=this.lensLeftPos=this.windowLeftPos=0),"window"==this.options.zoomType&&(this.Eboppos&&(this.lensTopPos=Math.max(this.nzHeight-this.zoomLens.height()-2*this.options.lensBorderSize,0)),this.Eroppos&&(this.lensLeftPos=this.nzWidth-this.zoomLens.width()-2*this.options.lensBorderSize)),"inner"==this.options.zoomType&&(this.Eboppos&&(this.lensTopPos=Math.max(this.nzHeight-2*this.options.lensBorderSize,0)),this.Eroppos&&(this.lensLeftPos=this.nzWidth-this.nzWidth-2*this.options.lensBorderSize)),
"lens"==this.options.zoomType&&(this.windowLeftPos=String(-1*((b.pageX-this.nzOffset.left)*this.widthRatio-this.zoomLens.width()/2)),this.windowTopPos=String(-1*((b.pageY-this.nzOffset.top)*this.heightRatio-this.zoomLens.height()/2)),this.zoomLens.css({backgroundPosition:this.windowLeftPos+"px "+this.windowTopPos+"px"}),this.changeBgSize&&(this.nzHeight>this.nzWidth?("lens"==this.options.zoomType&&this.zoomLens.css({"background-size":this.largeWidth/this.newvalueheight+"px "+this.largeHeight/this.newvalueheight+
"px"}),this.zoomWindow.css({"background-size":this.largeWidth/this.newvalueheight+"px "+this.largeHeight/this.newvalueheight+"px"})):("lens"==this.options.zoomType&&this.zoomLens.css({"background-size":this.largeWidth/this.newvaluewidth+"px "+this.largeHeight/this.newvaluewidth+"px"}),this.zoomWindow.css({"background-size":this.largeWidth/this.newvaluewidth+"px "+this.largeHeight/this.newvaluewidth+"px"})),this.changeBgSize=!1),this.setWindowPostition(b)),this.options.tint&&"inner"!=this.options.zoomType&&
this.setTintPosition(b),"window"==this.options.zoomType&&this.setWindowPostition(b),"inner"==this.options.zoomType&&this.setWindowPostition(b),this.options.showLens&&(this.fullwidth&&"lens"!=this.options.zoomType&&(this.lensLeftPos=0),this.zoomLens.css({left:this.lensLeftPos+"px",top:this.lensTopPos+"px"})))},showHideWindow:function(b){"show"!=b||this.isWindowActive||(this.options.zoomWindowFadeIn?this.zoomWindow.stop(!0,!0,!1).fadeIn(this.options.zoomWindowFadeIn):this.zoomWindow.show(),this.isWindowActive=
!0);"hide"==b&&this.isWindowActive&&(this.options.zoomWindowFadeOut?this.zoomWindow.stop(!0,!0).fadeOut(this.options.zoomWindowFadeOut):this.zoomWindow.hide(),this.isWindowActive=!1)},showHideLens:function(b){"show"!=b||this.isLensActive||(this.options.lensFadeIn?this.zoomLens.stop(!0,!0,!1).fadeIn(this.options.lensFadeIn):this.zoomLens.show(),this.isLensActive=!0);"hide"==b&&this.isLensActive&&(this.options.lensFadeOut?this.zoomLens.stop(!0,!0).fadeOut(this.options.lensFadeOut):this.zoomLens.hide(),
this.isLensActive=!1)},showHideTint:function(b){"show"!=b||this.isTintActive||(this.options.zoomTintFadeIn?this.zoomTint.css({opacity:this.options.tintOpacity}).animate().stop(!0,!0).fadeIn("slow"):(this.zoomTint.css({opacity:this.options.tintOpacity}).animate(),this.zoomTint.show()),this.isTintActive=!0);"hide"==b&&this.isTintActive&&(this.options.zoomTintFadeOut?this.zoomTint.stop(!0,!0).fadeOut(this.options.zoomTintFadeOut):this.zoomTint.hide(),this.isTintActive=!1)},setLensPostition:function(b){},
setWindowPostition:function(b){var a=this;if(isNaN(a.options.zoomWindowPosition))a.externalContainer=d("#"+a.options.zoomWindowPosition),a.externalContainerWidth=a.externalContainer.width(),a.externalContainerHeight=a.externalContainer.height(),a.externalContainerOffset=a.externalContainer.offset(),a.windowOffsetTop=a.externalContainerOffset.top,a.windowOffsetLeft=a.externalContainerOffset.left;else switch(a.options.zoomWindowPosition){case 1:a.windowOffsetTop=a.options.zoomWindowOffety;a.windowOffsetLeft=
+a.nzWidth;break;case 2:a.options.zoomWindowHeight>a.nzHeight&&(a.windowOffsetTop=-1*(a.options.zoomWindowHeight/2-a.nzHeight/2),a.windowOffsetLeft=a.nzWidth);break;case 3:a.windowOffsetTop=a.nzHeight-a.zoomWindow.height()-2*a.options.borderSize;a.windowOffsetLeft=a.nzWidth;break;case 4:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=a.nzWidth;break;case 5:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=a.nzWidth-a.zoomWindow.width()-2*a.options.borderSize;break;case 6:a.options.zoomWindowHeight>
a.nzHeight&&(a.windowOffsetTop=a.nzHeight,a.windowOffsetLeft=-1*(a.options.zoomWindowWidth/2-a.nzWidth/2+2*a.options.borderSize));break;case 7:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=0;break;case 8:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 9:a.windowOffsetTop=a.nzHeight-a.zoomWindow.height()-2*a.options.borderSize;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 10:a.options.zoomWindowHeight>a.nzHeight&&
(a.windowOffsetTop=-1*(a.options.zoomWindowHeight/2-a.nzHeight/2),a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize));break;case 11:a.windowOffsetTop=a.options.zoomWindowOffety;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 12:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 13:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=
0;break;case 14:a.options.zoomWindowHeight>a.nzHeight&&(a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize),a.windowOffsetLeft=-1*(a.options.zoomWindowWidth/2-a.nzWidth/2+2*a.options.borderSize));break;case 15:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=a.nzWidth-a.zoomWindow.width()-2*a.options.borderSize;break;case 16:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=a.nzWidth;break;default:a.windowOffsetTop=
a.options.zoomWindowOffety,a.windowOffsetLeft=a.nzWidth}a.isWindowSet=!0;a.windowOffsetTop+=a.options.zoomWindowOffety;a.windowOffsetLeft+=a.options.zoomWindowOffetx;a.zoomWindow.css({top:a.windowOffsetTop});a.zoomWindow.css({left:a.windowOffsetLeft});"inner"==a.options.zoomType&&(a.zoomWindow.css({top:0}),a.zoomWindow.css({left:0}));a.windowLeftPos=String(-1*((b.pageX-a.nzOffset.left)*a.widthRatio-a.zoomWindow.width()/2));a.windowTopPos=String(-1*((b.pageY-a.nzOffset.top)*a.heightRatio-a.zoomWindow.height()/
2));a.Etoppos&&(a.windowTopPos=0);a.Eloppos&&(a.windowLeftPos=0);a.Eboppos&&(a.windowTopPos=-1*(a.largeHeight/a.currentZoomLevel-a.zoomWindow.height()));a.Eroppos&&(a.windowLeftPos=-1*(a.largeWidth/a.currentZoomLevel-a.zoomWindow.width()));a.fullheight&&(a.windowTopPos=0);a.fullwidth&&(a.windowLeftPos=0);if("window"==a.options.zoomType||"inner"==a.options.zoomType)1==a.zoomLock&&(1>=a.widthRatio&&(a.windowLeftPos=0),1>=a.heightRatio&&(a.windowTopPos=0)),a.largeHeight<a.options.zoomWindowHeight&&(a.windowTopPos=
0),a.largeWidth<a.options.zoomWindowWidth&&(a.windowLeftPos=0),a.options.easing?(a.xp||(a.xp=0),a.yp||(a.yp=0),a.loop||(a.loop=setInterval(function(){a.xp+=(a.windowLeftPos-a.xp)/a.options.easingAmount;a.yp+=(a.windowTopPos-a.yp)/a.options.easingAmount;a.scrollingLock?(clearInterval(a.loop),a.xp=a.windowLeftPos,a.yp=a.windowTopPos,a.xp=-1*((b.pageX-a.nzOffset.left)*a.widthRatio-a.zoomWindow.width()/2),a.yp=-1*((b.pageY-a.nzOffset.top)*a.heightRatio-a.zoomWindow.height()/2),a.changeBgSize&&(a.nzHeight>
a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})):("lens"!=a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"})),
a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.windowLeftPos+"px "+a.windowTopPos+"px"}),a.scrollingLock=!1,a.loop=!1):(a.changeBgSize&&(a.nzHeight>a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})):("lens"!=a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+
"px "+a.largeHeight/a.newvaluewidth+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"})),a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.xp+"px "+a.yp+"px"}))},16))):(a.changeBgSize&&(a.nzHeight>a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/
a.newvalueheight+"px"})):("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"}),a.largeHeight/a.newvaluewidth<a.options.zoomWindowHeight?a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"}):a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})),a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.windowLeftPos+
"px "+a.windowTopPos+"px"}))},setTintPosition:function(b){this.nzOffset=this.$elem.offset();this.tintpos=String(-1*(b.pageX-this.nzOffset.left-this.zoomLens.width()/2));this.tintposy=String(-1*(b.pageY-this.nzOffset.top-this.zoomLens.height()/2));this.Etoppos&&(this.tintposy=0);this.Eloppos&&(this.tintpos=0);this.Eboppos&&(this.tintposy=-1*(this.nzHeight-this.zoomLens.height()-2*this.options.lensBorderSize));this.Eroppos&&(this.tintpos=-1*(this.nzWidth-this.zoomLens.width()-2*this.options.lensBorderSize));
this.options.tint&&(this.fullheight&&(this.tintposy=0),this.fullwidth&&(this.tintpos=0),this.zoomTintImage.css({left:this.tintpos+"px"}),this.zoomTintImage.css({top:this.tintposy+"px"}))},swaptheimage:function(b,a){var c=this,e=new Image;c.options.loadingIcon&&(c.spinner=d("<div style=\"background: url('"+c.options.loadingIcon+"') no-repeat center;height:"+c.nzHeight+"px;width:"+c.nzWidth+'px;z-index: 2000;position: absolute; background-position: center center;"></div>'),c.$elem.after(c.spinner));
c.options.onImageSwap(c.$elem);e.onload=function(){c.largeWidth=e.width;c.largeHeight=e.height;c.zoomImage=a;c.zoomWindow.css({"background-size":c.largeWidth+"px "+c.largeHeight+"px"});c.zoomWindow.css({"background-size":c.largeWidth+"px "+c.largeHeight+"px"});c.swapAction(b,a)};e.src=a},swapAction:function(b,a){var c=this,e=new Image;e.onload=function(){c.nzHeight=e.height;c.nzWidth=e.width;c.options.onImageSwapComplete(c.$elem);c.doneCallback()};e.src=b;c.currentZoomLevel=c.options.zoomLevel;c.options.maxZoomLevel=
!1;"lens"==c.options.zoomType&&c.zoomLens.css({backgroundImage:"url('"+a+"')"});"window"==c.options.zoomType&&c.zoomWindow.css({backgroundImage:"url('"+a+"')"});"inner"==c.options.zoomType&&c.zoomWindow.css({backgroundImage:"url('"+a+"')"});c.currentImage=a;if(c.options.imageCrossfade){var f=c.$elem,g=f.clone();c.$elem.attr("src",b);c.$elem.after(g);g.stop(!0).fadeOut(c.options.imageCrossfade,function(){d(this).remove()});c.$elem.width("auto").removeAttr("width");c.$elem.height("auto").removeAttr("height");
f.fadeIn(c.options.imageCrossfade);c.options.tint&&"inner"!=c.options.zoomType&&(f=c.zoomTintImage,g=f.clone(),c.zoomTintImage.attr("src",a),c.zoomTintImage.after(g),g.stop(!0).fadeOut(c.options.imageCrossfade,function(){d(this).remove()}),f.fadeIn(c.options.imageCrossfade),c.zoomTint.css({height:c.$elem.height()}),c.zoomTint.css({width:c.$elem.width()}));c.zoomContainer.css("height",c.$elem.height());c.zoomContainer.css("width",c.$elem.width());"inner"!=c.options.zoomType||c.options.constrainType||
(c.zoomWrap.parent().css("height",c.$elem.height()),c.zoomWrap.parent().css("width",c.$elem.width()),c.zoomWindow.css("height",c.$elem.height()),c.zoomWindow.css("width",c.$elem.width()))}else c.$elem.attr("src",b),c.options.tint&&(c.zoomTintImage.attr("src",a),c.zoomTintImage.attr("height",c.$elem.height()),c.zoomTintImage.css({height:c.$elem.height()}),c.zoomTint.css({height:c.$elem.height()})),c.zoomContainer.css("height",c.$elem.height()),c.zoomContainer.css("width",c.$elem.width());c.options.imageCrossfade&&
(c.zoomWrap.css("height",c.$elem.height()),c.zoomWrap.css("width",c.$elem.width()));c.options.constrainType&&("height"==c.options.constrainType&&(c.zoomContainer.css("height",c.options.constrainSize),c.zoomContainer.css("width","auto"),c.options.imageCrossfade?(c.zoomWrap.css("height",c.options.constrainSize),c.zoomWrap.css("width","auto"),c.constwidth=c.zoomWrap.width()):(c.$elem.css("height",c.options.constrainSize),c.$elem.css("width","auto"),c.constwidth=c.$elem.width()),"inner"==c.options.zoomType&&
(c.zoomWrap.parent().css("height",c.options.constrainSize),c.zoomWrap.parent().css("width",c.constwidth),c.zoomWindow.css("height",c.options.constrainSize),c.zoomWindow.css("width",c.constwidth)),c.options.tint&&(c.tintContainer.css("height",c.options.constrainSize),c.tintContainer.css("width",c.constwidth),c.zoomTint.css("height",c.options.constrainSize),c.zoomTint.css("width",c.constwidth),c.zoomTintImage.css("height",c.options.constrainSize),c.zoomTintImage.css("width",c.constwidth))),"width"==
c.options.constrainType&&(c.zoomContainer.css("height","auto"),c.zoomContainer.css("width",c.options.constrainSize),c.options.imageCrossfade?(c.zoomWrap.css("height","auto"),c.zoomWrap.css("width",c.options.constrainSize),c.constheight=c.zoomWrap.height()):(c.$elem.css("height","auto"),c.$elem.css("width",c.options.constrainSize),c.constheight=c.$elem.height()),"inner"==c.options.zoomType&&(c.zoomWrap.parent().css("height",c.constheight),c.zoomWrap.parent().css("width",c.options.constrainSize),c.zoomWindow.css("height",
c.constheight),c.zoomWindow.css("width",c.options.constrainSize)),c.options.tint&&(c.tintContainer.css("height",c.constheight),c.tintContainer.css("width",c.options.constrainSize),c.zoomTint.css("height",c.constheight),c.zoomTint.css("width",c.options.constrainSize),c.zoomTintImage.css("height",c.constheight),c.zoomTintImage.css("width",c.options.constrainSize))))},doneCallback:function(){this.options.loadingIcon&&this.spinner.hide();this.nzOffset=this.$elem.offset();this.nzWidth=this.$elem.width();
this.nzHeight=this.$elem.height();this.currentZoomLevel=this.options.zoomLevel;this.widthRatio=this.largeWidth/this.nzWidth;this.heightRatio=this.largeHeight/this.nzHeight;"window"==this.options.zoomType&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/this.heightRatio),lensWidth=this.options.zoomWindowWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/this.widthRatio,this.zoomLens&&(this.zoomLens.css("width",
lensWidth),this.zoomLens.css("height",lensHeight)))},getCurrentImage:function(){return this.zoomImage},getGalleryList:function(){var b=this;b.gallerylist=[];b.options.gallery?d("#"+b.options.gallery+" a").each(function(){var a="";d(this).data("zoom-image")?a=d(this).data("zoom-image"):d(this).data("image")&&(a=d(this).data("image"));a==b.zoomImage?b.gallerylist.unshift({href:""+a+"",title:d(this).find("img").attr("title")}):b.gallerylist.push({href:""+a+"",title:d(this).find("img").attr("title")})}):
b.gallerylist.push({href:""+b.zoomImage+"",title:d(this).find("img").attr("title")});return b.gallerylist},changeZoomLevel:function(b){this.scrollingLock=!0;this.newvalue=parseFloat(b).toFixed(2);newvalue=parseFloat(b).toFixed(2);maxheightnewvalue=this.largeHeight/(this.options.zoomWindowHeight/this.nzHeight*this.nzHeight);maxwidthtnewvalue=this.largeWidth/(this.options.zoomWindowWidth/this.nzWidth*this.nzWidth);"inner"!=this.options.zoomType&&(maxheightnewvalue<=newvalue?(this.heightRatio=this.largeHeight/
maxheightnewvalue/this.nzHeight,this.newvalueheight=maxheightnewvalue,this.fullheight=!0):(this.heightRatio=this.largeHeight/newvalue/this.nzHeight,this.newvalueheight=newvalue,this.fullheight=!1),maxwidthtnewvalue<=newvalue?(this.widthRatio=this.largeWidth/maxwidthtnewvalue/this.nzWidth,this.newvaluewidth=maxwidthtnewvalue,this.fullwidth=!0):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue,this.fullwidth=!1),"lens"==this.options.zoomType&&(maxheightnewvalue<=newvalue?
(this.fullwidth=!0,this.newvaluewidth=maxheightnewvalue):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue,this.fullwidth=!1)));"inner"==this.options.zoomType&&(maxheightnewvalue=parseFloat(this.largeHeight/this.nzHeight).toFixed(2),maxwidthtnewvalue=parseFloat(this.largeWidth/this.nzWidth).toFixed(2),newvalue>maxheightnewvalue&&(newvalue=maxheightnewvalue),newvalue>maxwidthtnewvalue&&(newvalue=maxwidthtnewvalue),maxheightnewvalue<=newvalue?(this.heightRatio=this.largeHeight/
newvalue/this.nzHeight,this.newvalueheight=newvalue>maxheightnewvalue?maxheightnewvalue:newvalue,this.fullheight=!0):(this.heightRatio=this.largeHeight/newvalue/this.nzHeight,this.newvalueheight=newvalue>maxheightnewvalue?maxheightnewvalue:newvalue,this.fullheight=!1),maxwidthtnewvalue<=newvalue?(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue>maxwidthtnewvalue?maxwidthtnewvalue:newvalue,this.fullwidth=!0):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=
newvalue,this.fullwidth=!1));scrcontinue=!1;"inner"==this.options.zoomType&&(this.nzWidth>this.nzHeight&&(this.newvaluewidth<=maxwidthtnewvalue?scrcontinue=!0:(scrcontinue=!1,this.fullwidth=this.fullheight=!0)),this.nzHeight>this.nzWidth&&(this.newvaluewidth<=maxwidthtnewvalue?scrcontinue=!0:(scrcontinue=!1,this.fullwidth=this.fullheight=!0)));"inner"!=this.options.zoomType&&(scrcontinue=!0);scrcontinue&&(this.zoomLock=0,this.changeZoom=!0,this.options.zoomWindowHeight/this.heightRatio<=this.nzHeight&&
(this.currentZoomLevel=this.newvalueheight,"lens"!=this.options.zoomType&&"inner"!=this.options.zoomType&&(this.changeBgSize=!0,this.zoomLens.css({height:String(this.options.zoomWindowHeight/this.heightRatio)+"px"})),"lens"==this.options.zoomType||"inner"==this.options.zoomType)&&(this.changeBgSize=!0),this.options.zoomWindowWidth/this.widthRatio<=this.nzWidth&&("inner"!=this.options.zoomType&&this.newvaluewidth>this.newvalueheight&&(this.currentZoomLevel=this.newvaluewidth),"lens"!=this.options.zoomType&&
"inner"!=this.options.zoomType&&(this.changeBgSize=!0,this.zoomLens.css({width:String(this.options.zoomWindowWidth/this.widthRatio)+"px"})),"lens"==this.options.zoomType||"inner"==this.options.zoomType)&&(this.changeBgSize=!0),"inner"==this.options.zoomType&&(this.changeBgSize=!0,this.nzWidth>this.nzHeight&&(this.currentZoomLevel=this.newvaluewidth),this.nzHeight>this.nzWidth&&(this.currentZoomLevel=this.newvaluewidth)));this.setPosition(this.currentLoc)},closeAll:function(){self.zoomWindow&&self.zoomWindow.hide();
self.zoomLens&&self.zoomLens.hide();self.zoomTint&&self.zoomTint.hide()},changeState:function(b){"enable"==b&&(this.options.zoomEnabled=!0);"disable"==b&&(this.options.zoomEnabled=!1)}};d.fn.elevateZoom=function(b){return this.each(function(){var a=Object.create(k);a.init(b,this);d.data(this,"elevateZoom",a)})};d.fn.elevateZoom.options={zoomActivation:"hover",zoomEnabled:!0,preloading:1,zoomLevel:1,scrollZoom:!1,scrollZoomIncrement:0.1,minZoomLevel:!1,maxZoomLevel:!1,easing:!1,easingAmount:12,lensSize:200,
zoomWindowWidth:400,zoomWindowHeight:400,zoomWindowOffetx:0,zoomWindowOffety:0,zoomWindowPosition:1,zoomWindowBgColour:"#fff",lensFadeIn:!1,lensFadeOut:!1,debug:!1,zoomWindowFadeIn:!1,zoomWindowFadeOut:!1,zoomWindowAlwaysShow:!1,zoomTintFadeIn:!1,zoomTintFadeOut:!1,borderSize:4,showLens:!0,borderColour:"#888",lensBorderSize:1,lensBorderColour:"#000",lensShape:"square",zoomType:"window",containLensZoom:!1,lensColour:"white",lensOpacity:0.4,lenszoom:!1,tint:!1,tintColour:"#333",tintOpacity:0.4,gallery:!1,
galleryActiveClass:"zoomGalleryActive",imageCrossfade:!1,constrainType:!1,constrainSize:!1,loadingIcon:!1,cursor:"default",responsive:!0,onComplete:d.noop,onZoomedImageLoaded:function(){},onImageSwap:d.noop,onImageSwapComplete:d.noop}})(jQuery,window,document);
/****************************************************************
 * CODE product images
 * Create swiper from product images with a thumbnail navigation swiper
 * Load images on variantchange
 ****************************************************************/

!(function ($, document, window, undefined) {

  /**
   * Plugin name
   */
  var _pluginName = 'productImages';

  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return productImages_plugin
   */
  var productImages_plugin = function ($element, options) {

    // Scope it
    var self = this;
    self.$element = $element;

    // Create product Options
    var defaultOptions = {
      speed: 800,
      showVariantImageOnVariantChange: true,
      showVariantImageOnPageLoad: true,
      fancybox:{
        hash: false,
        backFocus: false,
        baseClass: "product-images-popup",
        thumbs : {
          autoStart   : true,
          hideOnClose : true
        }
      },
      productImagesSwiperSelector: '.product-images__slider',
      productImagesSwiperNavSelector: '.product-images__slider-nav'
    };
    var metaOptions = self.$element.data('product-images-options');
    self.options = $.extend({}, defaultOptions, metaOptions);

    if ($.code.debug) {
      console.log('Init productImages:', self.$element, self.options);
    }

    // Get elements
    self.$productImagesSwiper = $(self.options.productImagesSwiperSelector);
    self.$productImagesSwiperNav = $(self.options.productImagesSwiperNavSelector);

    if (self.$productImagesSwiper.length) {

      // Init product Swipers
      self.initProductSwipers();
    } else {

      // Init productzoom popup gallery
      self.initProductFancyboxGallery();
    }

    // If the PDP is loaded with a variant parameter, show the image of the variant
    if (self.options.showVariantImageOnPageLoad) {

      var currentVariantId = self.$element.find('[name="id"] option[selected]').attr('value');
      self.goToVariant(currentVariantId, 0);
    }

    // Catch masterSelectChange
    self.$element.on('masterSelectChange', function (event) {

      if (self.options.showVariantImageOnVariantChange) {

        // Get the variant id
        var variant_id = event.variant.id;

        // Go to the slide
        self.goToVariant(variant_id, self.options.speed);
      }
    });
  };

  /**
   * Init the product slideshow
   *
   * @return void
   * @access public
   */
  productImages_plugin.prototype.initProductSwipers = function () {
    var self = this;

    var swiperOptions = {};

    // If thumbnails must be a swiper
    if (typeof self.$productImagesSwiperNav.data('swiper-options') != 'undefined') {

      // Init thumbnail Swiper
      self.$productImagesSwiperNav.swiperLoader();

      // Set thumbnail instance as thumbs in options for Product image Swiper
      swiperOptions = {
        thumbs: {
          swiper: self.$productImagesSwiperNav.find('.swiper-container:first')[0].swiper
        }
      };
    } else {

      // Find all thumbnails
      var $thumbs = self.$productImagesSwiperNav.find('[data-product-thumb]');

      // Catch click on a thumbnail
      self.$productImagesSwiperNav.on('click','[data-product-thumb]',function(){
        var slideIndex = $thumbs.index($(this));

        // Tell Product images Swiper to show that image
        self.$productImagesSwiper.swiperLoader('goToSlide', slideIndex);
      });
    }

    // Init Product images Swiper
    self.$productImagesSwiper.swiperLoader(swiperOptions);

    // Get the Product image Swiper Instance
    self.productImagesSwiperInstance = self.$productImagesSwiper.find('.swiper-container:first')[0].swiper;

    // Init productzoom popup gallery
    self.initProductFancyboxGallery();
  };

  /**
   * Init the product fancybox Image popup slideshow
   *
   * @return void
   * @access public
   */
   productImages_plugin.prototype.initProductFancyboxGallery = function () {
    var self = this;

    // Init fancybox on all Product images, except for slide duplicates
    self.$element.find('[data-fancybox="productGallery"]').not('.swiper-slide-duplicate [data-fancybox]').fancybox(self.options.fancybox);
  };

  /**
   *
   * @param {object} Jquery element
   * @param {number} variantId
   * @param {number} speed
   * @return void
   */
   productImages_plugin.prototype.goToVariant = function (variantId, speed) {
    var self = this;

    if($.code.debug) {
      console.log('productImages goToVariant', {
        variantId: variantId,
        speed: speed
      });
    }

    if (typeof self.productImagesSwiperInstance == 'undefined') {
      return;
    }

    // Loop the slides in self.productImagesSwiperInstance
    $(self.productImagesSwiperInstance.slides).each(function(slideIndex, element){

      // Get variant Ids for this slide
      var ids = $(element).data('product-variant-image');

      if (typeof ids == 'undefined') {
        return;
      }

      for (var index = 0; index < ids.length; index++) {
        var id = ids[index];

        // If this slide has the variantId
        if (id == variantId) {

          if (self.options.swiperLoop) {
            slideIndex -= 1;
          }

          // Tell slider to go to this slide
          self.$productImagesSwiper.swiperLoader('goToSlide', slideIndex, speed);

          // Stop loop
          return false;
        }
      }
    });
  };

  /**
   * product plugin
   *
   * @return jQuery objects
   */
  $.fn.productImages = function (options) {

    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // Initialize the items
    return this.each(function () {

      // Store the element the plugin is set on
      var $element = $(this);

      // Guard if plugin was already initted
      var instance = $element.data('plugin_' + _pluginName);

      // If plugin was not innited
      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new productImages_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };

})(jQuery, document, window);

/****************************************************************
 * CODE relatedProducts
 ****************************************************************/

!(function ($, document, window, undefined) {

  /**
   * Plugin name
   */
  var _pluginName = 'relatedProducts';

  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return relatedProducts_plugin
   */
  var relatedProducts_plugin = function ($element, options) {

    // Scope it
    var self = this;
    self.$element = $element;
    self.xhrCount = 0;

    // Set default options
    var defaults = {
      view: 'product-related',          // view for liquid files collection.product-related.liquid and product.product-related.liquid
      max: 5,                           // max products
      currentHandle: '',                // handle of the current product
      relatedMetaHandles: '',           // array of product handles
      relatedSameCollectionHandles: '', // array of product handles
      relatedPrimaryTag: '',            // tag to filter primary collection
      relatedPrimaryCollection: '',     // primary collection handle
      relatedSecondaryTag: '',          // tag to filter secondary collection
      relatedSecondaryCollection: '',   // secondary collection handle
      columnClasses: '',                // classes for no-slider columns
      wrapper: ''                       // jQuery selector to show hide wrapper
    };

    // Get options from html element
    var metaOptions = self.$element.data('relatedProducts');
    self.options = $.extend({}, defaults, metaOptions);

    // Create the ajax url for the Primary collection
    // This uses collection.product-related.liquid
    if (self.options.relatedPrimaryCollection != '' && self.options.relatedPrimaryTag != '') {
      self.options.relatedPrimaryCollectionUrl = '/collections/' + self.options.relatedPrimaryCollection + '/' + self.options.relatedPrimaryTag + '?view=' + self.options.view;
    }

    // Create the ajax url for the Secondary collection
    // This uses collection.product-related.liquid
    if (self.options.relatedSecondaryCollection != '' && self.options.relatedSecondaryTag != '' ) {
      self.options.relatedSecondaryCollectionUrl = '/collections/' + self.options.relatedSecondaryCollection + '/' + self.options.relatedSecondaryTag + '?view=' + self.options.view;
    }

    // Create array for Metafield related products
    var relatedProducts_Metafield = [];
    if (Array.isArray(self.options.relatedMetaHandles)) {
      relatedProducts_Metafield = self.options.relatedMetaHandles;
    }

    // Create array for products from the same collection (without tag filtering)
    var relatedProducts_SameCollection = [];
    if (Array.isArray(self.options.relatedSameCollectionHandles)) {
      relatedProducts_SameCollection = self.options.relatedSameCollectionHandles;
    }

    var ajax1, ajax2;

    // Get an array of collection products filtered by relatedPrimaryTag (only first 1000 of this collection)
    if (typeof self.options.relatedPrimaryCollectionUrl != 'undefined') {
      ajax1 = $.ajax(self.options.relatedPrimaryCollectionUrl);
    }

    // Get an array of all products filtered by tag (only first 1000 of all_products)
    if (typeof self.options.relatedSecondaryCollectionUrl != 'undefined') {
      ajax2 = $.ajax(self.options.relatedSecondaryCollectionUrl);
    }

    if ($.code.debug) {
      console.log('Init relatedProducts:', self.$element, self.options);
    }

    // Find wrapper element
    self.$wrapper = $(self.options.wrapper);
    self.$container = self.$element.find('[data-related-products-container]');

    if (!self.$wrapper.length) {
      self.$wrapper = self.$element;
    }

    $.when( ajax1, ajax2 )
    .done(function( a1, a2 ) {

      var relatedProducts_PrimaryCollection = [];
      var relatedProducts_SecondaryCollection = [];

      if (typeof a1 != 'undefined') {
        relatedProducts_PrimaryCollection = a1[0].split(',');
      }
      if (typeof a2 != 'undefined') {
        relatedProducts_SecondaryCollection = a2[0].split(',');
      }

      // Concat all arrays and remove duplicates
      var relatedProductHandles = [].concat(
        relatedProducts_Metafield,
        relatedProducts_PrimaryCollection,
        relatedProducts_SecondaryCollection,
        relatedProducts_SameCollection
      );

      // Make the product handles unique, regardless of the collection prefix
      var relatedProductHandles_unique = [];
      var testArr = [];
      $.each(relatedProductHandles, function(index, handle) {

        var shortHandle = handle;

        // Remove collection prefix from handle
        if (handle.indexOf('|') > -1) {
          var res = handle.split('|');
          shortHandle = res[1];
        }

        // if shortHandle is not in testarray and not the current product
        if ($.inArray(shortHandle, testArr) == -1 && shortHandle !== self.options.currentHandle) {

          // Add shortHandle to testarray
          testArr.push(shortHandle);

          // Add real handle to unique array
          relatedProductHandles_unique.push(handle);
        }
      });

      // Remove products > max items
      var relatedProductHandles_arr = relatedProductHandles_unique.slice(0, self.options.max);

      if ($.code.debug) {
        console.log('relatedProducts_Metafield ' + self.options.wrapper, relatedProducts_Metafield);
        console.log('relatedProducts_PrimaryCollection ' + self.options.wrapper, self.options.relatedPrimaryCollectionUrl, relatedProducts_PrimaryCollection);
        console.log('relatedProducts_SecondaryCollection ' + self.options.wrapper, self.options.relatedSecondaryCollectionUrl, relatedProducts_SecondaryCollection);
        console.log('relatedProducts_SameCollection ' + self.options.wrapper, relatedProducts_SameCollection);
        console.log('relatedProductHandles ' + self.options.wrapper, relatedProductHandles_arr);
      }

      // create empty array to hold our items
      var responseArray = [];

      // map product urls to array
      var productsArray = $.map(relatedProductHandles_arr, function(handle, i) {
        var collectionHandle = 'all';
        var shortHandle = handle;

        // Split the collection|product_handle
        if (handle.indexOf('|') > -1) {
          var res = handle.split('|');
          collectionHandle = res[0];
          shortHandle = res[1];
        }

        var productUrl = '/collections/'+ collectionHandle +'/products/'+ shortHandle;

        // Store the relation
        var relation = '';
        if ($.inArray(handle, relatedProducts_SecondaryCollection) > -1 ) { relation = 'secondary collection'; }
        if ($.inArray(handle, relatedProducts_PrimaryCollection) > -1 ) { relation = 'primary collection'; }
        if ($.inArray(handle, relatedProducts_SameCollection) > -1 ) { relation = 'same collection'; }
        if ($.inArray(handle, relatedProducts_Metafield) > -1 ) { relation = 'metafield'; }

        // Related product original object
        return {
          index: i,
          collectionHandle: collectionHandle,
          relation: relation,
          url: productUrl
        };
      });

      // create deferred ajax request to pass product urls to
      var ajax_request = function(product) {
        var deferred = $.Deferred();

        $.ajax({
          url: product.url + '?view=' + self.options.view,
          success: function(data) {
            // mark the ajax call as completed
            deferred.resolve(data).done(function(data) {
              // Related product response/final object
              responseArray[product.index] = {
                index: product.index,
                collectionHandle: product.collectionHandle,
                relation: product.relation,
                html: data
              };
            });
          },
          error: function(error) {
            // mark the ajax call as completed, no reject, this breaks the chain
            deferred.resolve();
          }
        });

        return deferred.promise();
      };

      // define looper
      var looper = $.Deferred().resolve();

      // go through each product url and call the ajax function
      $.when.apply($, $.map(productsArray, function(product, i) {
        looper = looper.then(function() {

          // trigger ajax call with product data
          return ajax_request(product);
        });

        return looper;
      })).done(function() {

        // All ajax calls have completed
        if ($.code.debug) {
          console.log('Related products original array', productsArray);
          console.log('Related products ajax response array', responseArray);
        }

        // empty the container
        self.$container.empty();

        for (var index = 0; index < responseArray.length; index++) {

          var element = responseArray[index];

          if (typeof element != 'undefined') {

            // Create element
            var $element = $(element.html).attr('data-related-by', element.relation);

            // Add to container
            self.$container.append($element);
          }
        }
        self.render();
      });
    });
  };

  /**
   * Render products
   *
   * @return void
   * @access public
   */
  relatedProducts_plugin.prototype.render = function () {
    var self = this;

    if (self.$container.children().length > 0) {

      // Show the wrapper
      self.$wrapper.show();
    } else {

      // Hide the wrapper
      self.$wrapper.remove();
      return;
    }

    // Init Swiper
    var $swiperWrapper = self.$container.closest('[data-swiper-options]');
    if ($swiperWrapper.length) {

      // Add classes
      self.$container.children().addClass('swiper-slide');

      // Start swiper
      $swiperWrapper.swiperLoader();
    } else {
      self.$container.children().addClass(self.options.columnClasses);
    }
  };

  /**
   * relatedProducts plugin
   *
   * @return jQuery objects
   */
  $.fn.relatedProducts = function (options) {

    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // Initialize the items
    return this.each(function () {

      // Store the element the plugin is set on
      var $element = $(this);

      // Guard if plugin was already initted
      var instance = $element.data('plugin_' + _pluginName);

      // If plugin was not innited
      if (!instance) {

        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new relatedProducts_plugin($element, options));
      } else {

        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };

})(jQuery, document, window);

/****************************************************************
 * CODE product
 ****************************************************************/

!(function ($, document, window, undefined) {

  /**
   * Plugin name
   */
  var _pluginName = 'colorSwatch';

  /**
   * @param jQuery Element Wrapping container div
   * @return colorSwatch_plugin
   */
  var colorSwatch_plugin = function ($element, options) {

    // scope it
    var self = this;
    self.$element = $element;

    // Set default options
    var defaults = {
      view: 'color-swatch',             // view for collection liquid output
      viewJson: 'color-swatch-json',    // view for collection json output
      swatchProdCategory: '',           // category of the current product
      swatchProdCollection: '',         // collection of the current product
      swatchProdColor: '',              // color of the current product
      swatchProdHandle: '',             // handle of the current product
      swatchProdSize: '',               // size of the current product
      swatchProdType: ''                // type of the current product
    };

    var metaOptions = self.$element.data('color-swatch');
    self.options = $.extend({}, defaults, metaOptions);

    if (self.options.swatchProdCollection == '') {
      self.options.swatchProdCollection = '/collections/all';
    }

    if ($.code.debug) {
      console.log('Init colorSwatch:', self.$element, self.options);
    }

    self.init();
  };

  /**
   * Init the product
   * @return void
   * @access public
   */
  colorSwatch_plugin.prototype.init = function () {
    var self = this;

      // build ajax url with the filter tags that we have
      var ajaxUrl = self.buildUrl(self.options.swatchProdCollection, self.options.swatchProdCategory, self.options.swatchProdSize, self.options.swatchProdType, self.options.view);

      if ($.code.debug) {
        console.log('colorSwatch init ajaxUrl:', window.location.protocol + "//" + window.location.host + ajaxUrl);
      }

      // get the data
      $.get(ajaxUrl).done(function (dataReceived) {

        // insert the data
        self.$element.html(dataReceived);

        // add active class for color switch
        if (self.options.swatchProdHandle != '') {
          self.$element.find('[href$="' + self.options.swatchProdHandle + '"]').addClass('active');
        }

        // add active class for size switch
        if (self.options.swatchProdSize != '') {
          self.$element.find('input#' + self.options.swatchProdSize + ' + label').addClass('active');
        }

        // add active class for type switch
        if (self.options.swatchProdType != '') {
          self.$element.find('input#' + self.options.swatchProdType + ' + label').addClass('active');
        }

      });

      // when size or type filter is clicked, get the value
      self.$element.closest('[data-product-swatch-wrapper]').on('change', 'input[type="radio"]', function () {

        var filterTag = $(this).val();

        // check which filter is changed (size or type)
        var filterTagSplit = filterTag.split('-');
        var filterTagKey = filterTagSplit[0];

        // when it's the size filter
        if (self.options.swatchProdSize.includes(filterTagKey) ) {

          // build and update ajax url with the new size tag
          ajaxUrl = self.buildUrl(self.options.swatchProdCollection, self.options.swatchProdCategory, filterTag, self.options.swatchProdType, self.options.viewJson);
          self.updateUrl(ajaxUrl);

        }

        // when it's the type filter
        else if (self.options.swatchProdType.includes(filterTagKey) ) {

          // build and update ajax url with the new size tag
          ajaxUrl = self.buildUrl(self.options.swatchProdCollection, self.options.swatchProdCategory, self.options.swatchProdSize, filterTag, self.options.viewJson);
          self.updateUrl(ajaxUrl);

        }


      });



  };

  colorSwatch_plugin.prototype.buildUrl = function (collectionUrl, cat, size, type, view) {
    var self = this;

    // when we don't have all data, don't build ajax url
    if (collectionUrl == '' && cat == '' && size == '' && type == '' && view == '' ) {
      return false;
    }

    // build ajax url
    var ajaxUrl = `${collectionUrl}`;

    // add category to ajax url
    var urlPartCat = `/${cat}`;
    ajaxUrl = ajaxUrl.concat(urlPartCat);

    // add size to ajax url
    var urlPartSize = `+${size}`;
    ajaxUrl = ajaxUrl.concat(urlPartSize);

    // add type to ajax url
    var urlPartType = `+${type}`;
    ajaxUrl = ajaxUrl.concat(urlPartType);

    // add view to ajax url
    var urlPartView = `?view=${view}`;
    ajaxUrl = ajaxUrl.concat(urlPartView);

    return ajaxUrl;

  }

  colorSwatch_plugin.prototype.updateUrl = function (ajaxUrl) {
    var self = this;

    if ($.code.debug) {
      console.log('colorSwatch update Url:', window.location.protocol + "//" + window.location.host + ajaxUrl);
    }

    // here the collection.color-swatch-json is used to get the first product of the filtered collection.
    $.get(ajaxUrl)
      .done(function (dataReceived) {

        // check if we have a json string
        if (self.isJsonString(dataReceived)) {

          // get the first product object of filtered collection
          var productObject = JSON.parse(dataReceived);

          // open the first product
          if (self.options.swatchProdCollection != '' && productObject.handle != '') {
            window.location.href = `${self.options.swatchProdCollection}/products/${productObject.handle}`;
          }

        } else {
          alert( "error" );
          return false;
        }

      })
       .fail(function() {
        alert( "error" );
      });

  }

  colorSwatch_plugin.prototype.isJsonString = function (string) {
    var self = this;
    try {
        JSON.parse(string);
    } catch (e) {
        return false;
    }
    return true;

  };

  /**
   * product plugin
   * @return jQuery objects
   */
  $.fn.colorSwatch = function (options) {

    // put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // initialize the items
    return this.each(function () {

      // store the element the plugin is set on
      var $element = $(this);

      // guard if plugin was already initted
      var instance = $element.data('plugin_' + _pluginName);

      // if plugin was not innited
      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new colorSwatch_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };

})(jQuery, document, window);
/****************************************************************
 * CODE product
 ****************************************************************/

!(function ($, document, window, undefined) {

  /**
   * Plugin name
   */
  var _pluginName = 'productConfigurator';

  /**
   * @param jQuery Element Wrapping container div
   * @return productConfigurator
   */
  var productConfigurator_plugin = function ($element, options) {

    // scope it
    var self = this;
    self.$element = $element;

    // Set default options
    var defaults = {
      configuratorSku: '',
      configuratorLanguage: 'us_en',
      configuratorUi: 'false',
      prodCollection: '',
      view: 'color-swatch-json'
    };

    var metaOptions = self.$element.data('product-configurator');
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log('Init productConfigurator:', self.$element, self.options);
    }

    self.init();
  };

  /**
   * Init the product
   * @return void
   * @access public
   */
  productConfigurator_plugin.prototype.init = function () {
    var self = this;

    // create fallback for collection
    if (self.options.prodCollection == '') {
      self.options.prodCollection = '/collections/all';
    }

    /*
      - We can only load the (right) configurator when we have a product sku
      - The loadConfigurator function is meant to insert the configurator without ui on top of the second (enlarged) product image
    */
    if (self.options.configuratorSku != '') {
      self.loadConfigurator(self.options.configuratorSku);
    }

    // listen to messages from window
    window.addEventListener('message', function(e) {

      // When the 'saved' button is clicked inside the configurator popup, we get a message in the console with the data output json
      if (e && e.data && e.data.personalized) {

        if ($.code.debug) {
          console.log('Json from configurator', e);
        }

        // save e.data in sessionStorage
        var key = `configurator-${e.data.sku}`;
        sessionStorage.setItem(key, JSON.stringify(e.data));

        // Check if product is not changed during configurating
        if ( self.options.configuratorSku == e.data.sku) {

          // if sku is still the same, we stay on the current pdp and pre-select the right product variant
          self.outputConfiguratorHandling(key);

          // close configurator
          self.closeConfigurator();

        } else {
          // if product is changed during configurating:

          // get first product object by sku with an ajax call
          var ajaxUrl = `${self.options.prodCollection}/sku-${e.data.sku}?view=${self.options.view}`;

          $.get(ajaxUrl).done(function (dataReceived) {

            // check if the dataReceived is not empty
            if (dataReceived || dataReceived.length > 0 ) {

              // check if we got a string
              if (typeof dataReceived === "string" ) {

                // parse string into an object
                var productObject = JSON.parse(dataReceived);

                // open the pdp
                if (self.options.prodCollection != '' && productObject.handle != '') {
                  window.location.href = `${self.options.prodCollection}/products/${productObject.handle}`;
                }
              }
            } else {
              if ($.code.debug) {
                console.log('No product found. AjaxUrl:', ajaxUrl);
              }
            }
          });

        }
      }

      // if configurator is loaded show it
      else if (e && e.data && e.data.loaded === true) {
        var iframeWrapper = document.getElementById('product-configurator-iframe-wrapper');
        iframeWrapper.classList.add("show");
      }

      // if cancelled in the configurator is clicked, close popup.
      else if (e && e.data && e.data.cancelled === true ) {

        // close configurator
        self.closeConfigurator();
      }

      // if personalization is empty
      else if ( e && e.data && e.data.personalized === false ) {

        // reset configurator
        self.resetConfigurator();

        // close configurator
        self.closeConfigurator();
      }

    }, false);

    // when navigated to another pdp, wait until page is loaded
    window.addEventListener('load', function () {

      // pre-select the right product variant
      var key = `configurator-${self.options.configuratorSku}`;
      self.outputConfiguratorHandling(key);

    });

  };

  productConfigurator_plugin.prototype.loadConfigurator = function (sku) {
    var self = this;

    if (sku == undefined ) {
      return false;
    }

    var iframe = document.createElement("iframe");
    iframe.loading = 'lazy';
    iframe.src = self.buildConfiguratorUrl(sku, self.options.configuratorLanguage, self.options.configuratorUi);
    iframe.id = 'product-configurator-iframe';

    if (iframe.attachEvent){
        iframe.attachEvent("onload", function(){
          if ($.code.debug) {
            console.log("iframe is loaded");
          }
        });
    } else {
        iframe.onload = function(){
          if ($.code.debug) {
            console.log("iframe is loaded");
          }
        };
    }

    let callbackWindowMessage = function(message){
      if ('https://kambukkapersonalizer-92a835f87d07.victhorious.com' !== message.origin
          && 'https://configurator.kambukka.com' !== message.origin
      ) {
        return;
      }

      if (!message.data.loaded) {
        return;
      }

      self.registerConfiguratorClickEvent();
      window.removeEventListener('message', callbackWindowMessage);
    };

    window.addEventListener('message', callbackWindowMessage);

    // get iframe wrapper
    var iframeWrapper = document.getElementById('product-configurator-iframe-wrapper');

    // append iframe to wrapper
    iframeWrapper.appendChild(iframe);
  };

  productConfigurator_plugin.prototype.buildConfiguratorUrl = function (sku, lang = 'us_en', ui = 'false') {

    var self = this;

    if (sku == undefined ) {
      return false;
    }

    // build configurator url
    var configuratorUrl = 'https://configurator.kambukka.com/';

    // add sku to url
    var urlPartSku = `?sku=${sku}`;
    configuratorUrl = configuratorUrl.concat(urlPartSku);

    // add lang to url
    var urlPartSize = `&l=${lang}`;
    configuratorUrl = configuratorUrl.concat(urlPartSize);

    // add ui to url
    var urlPartUi = `&ui=${ui}`;
    configuratorUrl = configuratorUrl.concat(urlPartUi);

    return configuratorUrl;
  };

  productConfigurator_plugin.prototype.selectProductVariant = function (querySelector, valueToSelect) {
    var self = this;

    // get select element
    var selectDropdown = document.querySelector(querySelector);

    // lowercase the value to select
    var valueToSelectLower = valueToSelect.toLowerCase();

    // loop through the dropdown options and lowercase the option value
    Array.from(selectDropdown.options).forEach(function(optionElement) {
        var optionValue = optionElement.value;
        var optionValueLower = optionValue.toLowerCase();

        // get the value to select when we have a match
        if (valueToSelectLower === optionValueLower ) {
          valueToSelect = optionValue;
        }
    });

    if ( selectDropdown == null ) {
      return false;
    }

    // set value of the select element
    selectDropdown.value = valueToSelect;

    // trigger change of the select element
    $(querySelector).val(selectDropdown.value).trigger('change');

  };

  productConfigurator_plugin.prototype.outputConfiguratorHandling = function (sessionStorageKey) {
    var self = this;

    // get item from sessionStorage
    var retrievedItem = sessionStorage.getItem(sessionStorageKey);

    // check if there is a value and this value is a json string
    if (retrievedItem != null && self.isJsonString(retrievedItem)) {

      // from string to object
      var retrievedItemParsed = JSON.parse(retrievedItem);

      // check if we are still in the correct product
      if (retrievedItemParsed.sku === self.options.configuratorSku ) {

        // pre-select the right product variant
        self.selectProductVariant('[data-single-option-selector-personalization]', retrievedItemParsed.personalized);

        // add configurator output as a string to product properties - cart line item properties
        var inputID = `product-personalization-${retrievedItemParsed.sku}`;
        var inputPersonalizationProperty = document.getElementById(inputID);
        inputPersonalizationProperty.value = retrievedItem;

        /*
          - add a message to the pdp below the configurator trigger that you've added a personalization.
          - you are able to remove the personalization
          - you are able to edit the personalization
          - we add a date to end of image url to prevent caching
        */
        var dt = new Date();
        var message = `Personalization: ${retrievedItemParsed.personalized}`;
        var imagePopup = `<a data-fancybox href="${retrievedItemParsed.url}?${dt.getTime()}" data-fancybox="images" data-options='{"baseClass": "product-configurator__image-popup", "buttons": ["close"] }' href="javascript:;">(Show)</a>`;
        var messageWrapper = document.querySelector('[data-product-configurator-message]');
        var triggerText = document.querySelector('[data-product-configurator-trigger-text]');
        var triggerTextEdit = document.querySelector('[data-product-configurator-trigger-text-edit]');
        triggerText.classList.add('hidden');
        triggerTextEdit.classList.remove('hidden');
        triggerTextEdit.classList.add('show');
        messageWrapper.style.display = 'block';
        messageWrapper.innerHTML = `
            <p class="product-configurator__message-text">
              ${message}${imagePopup}
              <span class="product-configurator__reset" title="Remove" data-product-configurator-reset>
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M.81 2.44H12.2M7.72.81H5.28a.81.81 0 00-.81.81v.82h4.06v-.81A.81.81 0 007.72.8zM5.28 9.34V5.28M7.72 9.34V5.28" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.22 11.44a.81.81 0 01-.81.75H3.59a.81.81 0 01-.8-.75l-.76-9h8.94l-.75 9z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </p>
        `;


        var resetButton = document.querySelector('[data-product-configurator-reset]');
        resetButton.addEventListener('click', function () {

          self.resetConfigurator();

          // reload window
          window.location.reload();

        });

        var addToCartButton = document.querySelector('[data-add-to-cart]');
        var configuratorMessage = document.querySelector('[data-product-configurator-message]');
        var configuratorTriggerText = document.querySelector('[data-product-configurator-trigger-text]');
        var configuratorTriggerTextEdit = document.querySelector('[data-product-configurator-trigger-text-edit]');
        addToCartButton.addEventListener('click', function () {

          setTimeout(function(){
            self.resetConfigurator();
            configuratorMessage.style.display = 'none';
            configuratorTriggerText.classList.remove('hidden');
            configuratorTriggerTextEdit.classList.remove('show');
          }, 3000);

        });

      }

    } else {

      return false;

    }
  };

  productConfigurator_plugin.prototype.isJsonString = function (string) {
    var self = this;
    try {
        JSON.parse(string);
    } catch (e) {
        return false;
    }
    return true;

  };

  productConfigurator_plugin.prototype.removePersonalization = function (sessionStorageKey) {
    if (sessionStorageKey != '') {
      sessionStorage.removeItem(sessionStorageKey);
    }
  }

  productConfigurator_plugin.prototype.sentMessageToConfiguratorIframe = function (message) {

    var self = this;

    //expected origin of iFrame content
    var ORIGIN = "https://configurator.kambukka.com";

      //target the iFrame
      var win = document.getElementById("product-configurator-iframe").contentWindow;

      //send a message into the hosted iFrame...
      win.postMessage(message, ORIGIN);

      if ($.code.debug) {
        console.log('message sent to iframe');
      }
  }

  productConfigurator_plugin.prototype.resetConfigurator = function () {
    var self = this;

    // sent message to configurator iframe
    var clearMessage = JSON.stringify({ 'clear': 'true' });
    self.sentMessageToConfiguratorIframe(clearMessage);

    // remove key sessionStorage
    var key = `configurator-${self.options.configuratorSku}`;
    self.removePersonalization(key);

    // set product variant to no print variant
    self.selectProductVariant('[data-single-option-selector-personalization]', 'No print');

  }

  productConfigurator_plugin.prototype.closeConfigurator = function () {
    var self = this;

    // reset styles on iframe wrapper
    document.getElementById('product-configurator-iframe-wrapper').style.cssText = '';

    // remove fullscreen mode on iframe
    document.getElementById('product-configurator-iframe').style.cssText = '';
  }

  productConfigurator_plugin.prototype.registerConfiguratorClickEvent = function () {
    var self = this;
    // get click on personalisation trigger
    var personalizeButton = document.querySelector('[data-product-configurator-trigger]');
    personalizeButton.addEventListener('click', function(){
      if ($.code.debug) {
        console.log('Configurator trigger clicked');
      }
      // sent message to configurator iframe to show UI
      self.sentMessageToConfiguratorIframe(JSON.stringify({'showUI': true }));

      // make iframe wrapper full screen
      document.getElementById('product-configurator-iframe-wrapper').style.cssText = 'position: fixed; z-index: 10000;';

      // make iframe full screen but don't show it yet
      document.getElementById('product-configurator-iframe').style.cssText = 'width: 100%; height: 100%; opacity: 0';

      // show when iframe has it definite position (to avoid shifting from the top left)
      setTimeout(function () {
        // show iframe
        document.getElementById('product-configurator-iframe').style.cssText += 'opacity: 1;';
      }, 600);
    });
  }

  /**
   * product plugin
   * @return jQuery objects
   */
  $.fn.productConfigurator = function (options) {

    // put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // initialize the items
    return this.each(function () {

      // store the element the plugin is set on
      var $element = $(this);

      // guard if plugin was already initted
      var instance = $element.data('plugin_' + _pluginName);

      // if plugin was not innited
      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new productConfigurator_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };

})(jQuery, document, window);

/****************************************************************
 * CODE init
 ****************************************************************/

$.code.productInit = function () {

  // Init product Image Swipers
  $('[data-section-type="product"]').productImages();

  // Init related products
  $('[data-related-products]').relatedProducts();

  // init color swatch on product detail page
  $('[data-color-swatch]').colorSwatch();

  // init product configurator on product detail page
  $('[data-product-configurator]').productConfigurator();

};

$.code.productInit();
